import { Box, CircularProgress } from '@material-ui/core';
import React, { Component } from 'react';

export class Chargement extends Component {
    render() {
        return (
            <Box display="flex" alignItems="center" justifyContent="center" height='10rem'>
                <CircularProgress />
            </Box>
        );
    }
}
